export const firebaseConfig = {
    apiKey: "AIzaSyDCA74A2ejq41RulMGRLey6R7p4wyz34ZY",
    authDomain: "vladbasin-me.firebaseapp.com",
    projectId: "vladbasin-me",
    storageBucket: "vladbasin-me.appspot.com",
    messagingSenderId: "251480431257",
    appId: "1:251480431257:web:285292c3353c4ec1123608",
    measurementId: "G-ZFB9SY2C73"
};
